
import HomePage from "./HomePage";
import PortfolioPage from "./PortfolioPage";
import ContactPage from "./ContactPage";
import ProjectDetailPage from "./ProjectDetailPage";
import { HashRouter, Routes, Route } from "react-router-dom";
import NavLayout from "../layouts/NavLayout";

const Router = () => {
    const homeParams = ["/", "home" ];
    return (
        <HashRouter>
            <Routes>
           {
            homeParams.map(h=>  <Route key={Math.random(100)} path={h} element={ <NavLayout><HomePage /></NavLayout>} ></Route>)
           }
            <Route key={Math.random(100)} path="portfolio" element={<NavLayout><PortfolioPage /></NavLayout>} ></Route>
            <Route key={Math.random(100)} path="contact" element={<NavLayout><ContactPage /></NavLayout>} ></Route>
            <Route key={Math.random(100)} path="portfolio/:id" element={<NavLayout><ProjectDetailPage /></NavLayout>} ></Route>
            </Routes>
        </HashRouter>
      
    );
}

export default Router;